import React from 'react';

export const SvgAiGenerativeAudio = props => (
  <svg viewBox="0 0 24 24" fill="none" {...props}>
    <path
      d="M5.24001 10.7091C5.24001 13.9897 7.89944 16.6491 11.18 16.6491C13.8693 16.6491 16.1433 14.8611 16.8738 12.4068L18.7713 12.9714C17.8888 15.9366 15.3172 18.1748 12.17 18.5673V20.6091H16.46V22.5891H5.90001V20.6091H10.19V18.5647C6.28338 18.0773 3.26001 14.7478 3.26001 10.7091H5.24001Z"
      fill="currentColor"
    />
    <path
      d="M11.18 1.46913C12.1236 1.46913 12.9927 1.80047 13.6731 2.35214L13.0504 3.12171L12.4265 3.88999C12.086 3.6138 11.6532 3.44913 11.18 3.44913C10.0866 3.44913 9.20025 4.33581 9.20001 5.42913V10.7091C9.20001 11.8027 10.0865 12.6891 11.18 12.6891C12.2735 12.6891 13.16 11.8027 13.16 10.7091V9.05913H15.14V10.7091C15.14 12.8962 13.3671 14.6691 11.18 14.6691C8.99296 14.6691 7.22001 12.8962 7.22001 10.7091V5.42913C7.22025 3.24229 8.99311 1.46913 11.18 1.46913Z"
      fill="currentColor"
    />
    <path
      d="M17.5789 1.93835C17.9491 1.27453 18.9305 1.27308 19.3011 1.93835L19.3707 2.09046L20.1815 4.31667L22.409 5.12878C23.2747 5.44544 23.277 6.67288 22.409 6.99019L20.1815 7.80101L19.3707 10.0285C19.0543 10.8945 17.8267 10.8965 17.5093 10.0285L16.6972 7.80101L14.471 6.99019C13.6047 6.67378 13.6025 5.44598 14.471 5.12878L16.6972 4.31667L17.5093 2.09046L17.5789 1.93835Z"
      fill="currentColor"
    />
  </svg>
);
